import React from 'react'
import {
    AppBar,
    AppBarTypeMap,
    Box,
    IconButton,
    Toolbar,
    Typography,
    useTheme,
} from '@mui/material'
import User from './User'
import GlobalMenuButton from '../GlobalMenu/GlobalMenuButton'
import { toggleDrawer } from 'store/actions/drawer.action'
import MenuIcon from '@mui/icons-material/Menu'
import { useDispatch } from 'react-redux'
import HWAgentStatusIcon from 'components/HWAgent/HWAgentStatusIcon'
import { isEmpty } from 'lodash-es'
import FullScreenButton from 'components/Buttons/FullScreenButton'
import useInfo from 'hooks/useInfo/useInfo'
import HelpIcon from '@mui/icons-material/Help'
import { useAppSelector } from 'store/useStoreHook'
import { menuHelpWidth } from 'router/layouts/AdminLayout'
import SideHelpDocument from 'components/SideNavigation/SideHelpDocument/SideHelpDocument'

interface ApplcationBarProps {
    menuToggleBtn?: boolean
    titleText?: string
    position?: AppBarTypeMap['props']['position']
    hideHWagent?: boolean
    hideUser?: boolean
}

const SxFlex = {
    display: 'flex',
    alignItems: 'center',
    zIndex: 1001,
}

function ApplicationBar(props: ApplcationBarProps) {
    const {
        menuToggleBtn = true,
        titleText = '',
        position = 'static',
        hideHWagent = false,
        hideUser = false,
    } = props
    const dispatch = useDispatch()
    const theme = useTheme()
    const openSideHelp = useAppSelector((state) => state.ui.helpDocument.isOpen)

    const { toggleHelpDoc } = useInfo()

    return (
        <Box
            sx={{
                width: '100%',
                top: 0,
            }}
        >
            <AppBar elevation={0} position={position}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: (theme) =>
                            theme.palette.topside.default,
                        height: {
                            md: theme.spacing(8),
                            lg: theme.spacing(10),
                            xl: theme.spacing(10),
                        },
                        width: openSideHelp
                            ? `calc(100% - ${menuHelpWidth})`
                            : '100%',
                    }}
                >
                    <Box sx={SxFlex}>
                        {menuToggleBtn && (
                            <IconButton
                                onClick={() => dispatch(toggleDrawer())}
                                size="large"
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        )}
                        {!isEmpty(titleText) && (
                            <Typography variant="h5">{titleText}</Typography>
                        )}
                    </Box>
                    <Box sx={SxFlex}>
                        {!hideHWagent && <HWAgentStatusIcon />}
                        <FullScreenButton />
                        <IconButton
                            color="invertPrimary"
                            aria-label="help info"
                            onClick={toggleHelpDoc}
                        >
                            <HelpIcon />
                        </IconButton>
                        {!hideUser && <User />}
                        <GlobalMenuButton size="large" />
                    </Box>
                </Toolbar>
            </AppBar>
            <SideHelpDocument />
        </Box>
    )
}

export default ApplicationBar
